export type Client = {
  slug: string;
  name: string;
  region: string;
  industry: string;
  logo?: string;
  url?: string;
};

export const clients: Client[] = [
  {
    slug: 'nomad-partners',
    name: 'Nomad Partners',
    region: 'Bulgaria',
    industry: 'Recruitment',
  },
  {
    slug: 'pharmas',
    name: 'PharmaS',
    region: 'Croatia · MK office',
    industry: 'Pharmaceutical',
  },
  {
    slug: 'abela',
    name: 'Abela',
    region: 'Serbia · MK office',
    industry: 'Pharmaceutical',
  },
  {
    slug: 'bosnalijek',
    name: 'Bosnalijek',
    region: 'Bosnia · MK office',
    industry: 'Pharmaceutical',
  },
  {
    slug: 'fitofarm',
    name: 'Fitofarm',
    region: 'North Macedonia',
    industry: 'Pharmaceutical',
  },
  {
    slug: 'ladria',
    name: 'Ladria',
    region: 'MK office',
    industry: 'Cosmetics',
  },
  {
    slug: 'faculty-of-pharmacy-skopje',
    name: 'Faculty of Pharmacy — Skopje',
    region: 'North Macedonia',
    industry: 'Education · Public sector',
  },
  {
    slug: 'alfalab',
    name: 'Alfalab',
    region: 'North Macedonia',
    industry: 'Pharmaceutical',
  },
  {
    slug: 'globalnet-adv',
    name: 'Global Net ADV',
    region: 'Skopje, North Macedonia',
    industry: 'Marketing & Advertising',
  },
];
